<template>
    <div>
        <div v-if="company" class="py-4">
            <div class="col-6">
                <b-alert variant="info" show>
                    <b-icon-info-circle-fill class="mr-2"/> This information will be shown in the reports.
                </b-alert>

                <h3 class="mt-5 mb-3">Basic Information</h3>

                <b-form-group label="Name" label-for="company-name">
                    <b-form-input
                        :disabled="!this.canEditDetails"
                        id="company-name"
                        v-model="company.name"
                        size="lg"
                        :state="errors.name === null"
                        @input="errors.name = null"
                        placeholder="Enter company name"
                        required/>

                    <template v-if="errors.name !== null">
                        <b-form-invalid-feedback
                            v-for="(error, key) in errors.name"
                            :key="'name_error_' + key"
                            force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-form-group>

                <b-form-group label="Company Address" label-for="company-address">
                    <b-form-input
                        :disabled="!this.canEditDetails"
                        id="company-address"
                        v-model="company.address"
                        size="lg"
                        :state="errors.address === null"
                        @input="errors.address = null"
                        placeholder="Enter company address"
                        required/>

                    <template v-if="errors.address !== null">
                        <b-form-invalid-feedback
                            v-for="(error, key) in errors.address"
                            :key="'address_error_' + key"
                            force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-form-group>

                <h3 class="mt-5 mb-3">Contact Person</h3>

                <b-form-group label="Contact person name" label-for="company-contact_person_name">
                    <b-form-input
                        :disabled="!this.canEditDetails"
                        id="company-contact_person_name"
                        v-model="company.contact_person_name"
                        size="lg"
                        :state="errors.contact_person_name === null"
                        @input="errors.contact_person_name = null"
                        placeholder="Enter company contact person name"
                        required/>


                    <template v-if="errors.contact_person_name !== null">
                        <b-form-invalid-feedback
                            v-for="(error, key) in errors.contact_person_name"
                            :key="'contact_person_name_error_' + key"
                            force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-form-group>

                <b-form-group label="Contact person e-mail" label-for="company-contact_person_email">
                    <b-form-input
                        :disabled="!this.canEditDetails"
                        id="company-contact_person_email"
                        v-model="company.contact_person_email"
                        size="lg"
                        :state="errors.contact_person_email === null"
                        @input="errors.contact_person_email = null"
                        placeholder="Enter company contact person e-mail"
                        required/>

                    <template v-if="errors.contact_person_email !== null">
                        <b-form-invalid-feedback
                            v-for="(error, key) in errors.contact_person_email"
                            :key="'contact_person_email_error_' + key"
                            force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-form-group>

                <b-form-group label="Contact person phone" label-for="company-contact_person_phone_number">
                    <b-input-group-append>
                        <b-form-input
                            :disabled="!this.canEditDetails"
                            id="company-contact_person_phone_number"
                            v-model="company.contact_person_phone_number"
                            size="lg"
                            :state="errors.contact_person_phone_number === null"
                            @input="errors.contact_person_phone_number = null"
                            placeholder="Enter company contact person phone number"
                            required/>

                        <b-input-group-text>
                            <b-icon-info-circle v-b-tooltip.hover title="Will be displayed on all the reports"/>
                        </b-input-group-text>
                    </b-input-group-append>

                    <template v-if="errors.contact_person_phone_number !== null">
                        <b-form-invalid-feedback
                            v-for="(error, key) in errors.contact_person_phone_number"
                            :key="'contact_person_phone_number_error_' + key"
                            force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-form-group>

                <b-button class="mt-4" variant="danger" @click="saveCompany">Save</b-button>
            </div>
        </div>

        <b-alert v-else variant="danger" show>
            <b-spinner small variant="danger"/> Loading company information
        </b-alert>
    </div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    comments: {},
    data() {
        return {
            canEditDetails: false,
            companyLoaded: false,
            company: null,
            errors: {
                name: null,
                address: null,
                contact_person_name: null,
                contact_person_email: null,
                contact_person_phone_number: null
            },
            user: {}
        }
    },
    created() {
        this.$store.state.company.id = this.$route.params.company_id;

        if (typeof this.$store.state.user.id === 'undefined') {
            this.$store.dispatch('loadLoggedInUser').then((user) => {
                this.$store.state.user = user;
                console.log('usr', this.$store.state.user);
            });
        }

        this.$store.dispatch('loadCompany').then((company) => {
            this.company = company;
        });


    },
    mounted() {
       this.canEditDetails = this.hasManagerPermission('projects.edit');
    },
    methods: {
        saveCompany() {
            const token = this.$store.state.token;

            const data = {
                name: this.company.name,
                address: this.company.address,
                contact_person_name: this.company.contact_person_name,
                contact_person_email: this.company.contact_person_email,
                contact_person_phone_number: this.company.contact_person_phone_number
            }

            axios({
                url: this.$store.getters.apiBase,
                method: 'PUT',
                headers: {"Authorization": "Bearer " + token},
                data: data
            })
                .then(response => {
                    console.log('ere');
                })
                .catch(error => {
                    const responseData = error.response.data;

                    if (typeof responseData.errors !== 'undefined') {
                        for (const [key, error] of Object.entries(responseData.errors)) {
                            this.errors[key] = error;
                        }
                    } else if (typeof responseData.message !== 'undefined') {
                        alert(responseData.message);
                    } else {
                        alert('Something went wrong');
                    }
                });
        }
    },
    watch: {}

}
</script>
